import "./Spinner.css";
const Spinner = ({ size = 50 }) => {
  return (
    <div className="main-load">
      <center />
      <br />
      <br />
      <br />
      <div className="loader" id="loader"></div>
      <div className="loader" id="loader2"></div>
      <div className="loader" id="loader3"></div>
      <div className="loader" id="loader4"></div>

      <span id="text">LOADING...</span>
      <br />
    </div>
  );
};

export default Spinner;
